import dayjs from 'dayjs';

import { DATE_ISO_FORMAT, setSearchParams } from '@utils';

type TransactionsLink = {
  companyId: string;
  accountId: string;
  /**
   * A reconciliation window's *opening* reference date — exclusive, and left out to reach back as far
   * as the transactions go. An interval covers `(from, to]`, because the opening balance already
   * accounts for everything booked on its own day, so the filter starts the day after.
   */
  from?: string;
  /** The closing reference date. Inclusive, as the transactions page's own filter is. */
  to: string;
};

/**
 * That account's transactions over exactly the span a figure on this page was computed from.
 *
 * The page states amounts the bank moved that our transactions do not explain, and the next question
 * is always "then which transactions *do* we hold for those days" — which otherwise means opening the
 * company, finding the tab, picking the bank and typing two dates. The transactions page seeds both
 * its request and its visible controls from these parameters, so the answer arrives filtered rather
 * than merely scrolled to.
 *
 * The day-after on `from` is what makes the two agree. Passing the opening reference date itself would
 * list a transaction the reconciliation attributed to the interval *before* this one, and a link that
 * shows a different set than the figure beside it was computed from is worse than no link.
 */
export const transactionsLink = ({
  companyId,
  accountId,
  from,
  to,
}: TransactionsLink): string => {
  const query = setSearchParams({
    accountId,
    ...(from
      ? { dateFrom: dayjs(from).add(1, 'day').format(DATE_ISO_FORMAT) }
      : {}),
    dateTo: to,
  });

  return `/companies/${companyId}/transactions?${query}`;
};
